(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["supremo-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-supremo-reviews]';

    const setupCarousel = (section) => {
      if (!section || section.dataset.supremoReviewsReady === 'true') return;
      section.dataset.supremoReviewsReady = 'true';

      const getElements = () => {
        const carousel = section.querySelector('.jdgm-cards-carousel');
        const track = carousel?.querySelector('.jdgm-videos-container');
        const cards = track ? Array.from(track.querySelectorAll('.jdgm-card')) : [];
        return { carousel, track, cards };
      };

      const getVisibleCards = (cards) => {
        if (window.matchMedia('(max-width: 749px)').matches) return 1;
        return Math.min(4, cards.length);
      };

      const getCardRange = (cards) => {
        const visibleCards = getVisibleCards(cards);
        const reviewIds = cards.map((card) => card.dataset.reviewId).filter(Boolean);
        const uniqueCount = new Set(reviewIds).size || cards.length;
        const clonedCards = Math.max(0, cards.length - uniqueCount);
        const firstIndex = clonedCards > 0 ? Math.floor(clonedCards / 2) : 0;
        const lastIndex = Math.max(firstIndex, firstIndex + uniqueCount - visibleCards);

        return { visibleCards, firstIndex, lastIndex };
      };

      const moveTo = (requestedIndex, animate = true) => {
        const { track, cards } = getElements();
        if (!track || cards.length === 0) return;

        const { firstIndex, lastIndex, visibleCards } = getCardRange(cards);
        const index = Math.max(firstIndex, Math.min(requestedIndex, lastIndex));
        const firstOffset = cards[0].offsetLeft;
        const destination = cards[index].offsetLeft - firstOffset;

        track.style.transition = animate ? 'transform .45s cubic-bezier(.22,.61,.36,1)' : 'none';
        track.style.transform = `translateX(${-destination}px)`;
        section.dataset.supremoReviewsIndex = String(index);

        requestAnimationFrame(() => {
          const arrows = section.querySelectorAll('.jdgm-arrow');
          arrows.forEach((arrow) => {
            arrow.style.display = cards.length > visibleCards ? 'grid' : 'none';
          });
        });
      };

      section.addEventListener('click', (event) => {
        const arrow = event.target.closest('.jdgm-arrow');
        if (!arrow || !section.contains(arrow)) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        const { cards } = getElements();
        if (cards.length === 0) return;

        const { visibleCards, firstIndex, lastIndex } = getCardRange(cards);
        const currentIndex = Number(section.dataset.supremoReviewsIndex || firstIndex);
        const arrowLabel = (arrow.getAttribute('aria-label') || '').toLowerCase();
        const isPrevious = arrowLabel.includes('previous') || arrowLabel.includes('anterior');
        let nextIndex;

        if (isPrevious) {
          nextIndex = currentIndex <= firstIndex ? lastIndex : Math.max(firstIndex, currentIndex - visibleCards);
        } else {
          nextIndex = currentIndex >= lastIndex ? firstIndex : Math.min(lastIndex, currentIndex + visibleCards);
        }

        moveTo(nextIndex);
      }, true);

      let resizeFrame;
      window.addEventListener('resize', () => {
        cancelAnimationFrame(resizeFrame);
        resizeFrame = requestAnimationFrame(() => {
          moveTo(Number(section.dataset.supremoReviewsIndex || 0), false);
        });
      });

      const observer = new MutationObserver(() => {
        const { cards } = getElements();
        if (cards.length > 0) moveTo(Number(section.dataset.supremoReviewsIndex || 0), false);
      });

      observer.observe(section, { childList: true, subtree: true });
      window.setTimeout(() => {
        const { cards } = getElements();
        moveTo(getCardRange(cards).firstIndex, false);
      }, 500);
      window.setTimeout(() => {
        const { cards } = getElements();
        moveTo(getCardRange(cards).firstIndex, false);
      }, 1500);
    };

    const initialize = (root = document) => {
      root.querySelectorAll(selector).forEach(setupCarousel);
      if (root.matches?.(selector)) setupCarousel(root);
    };

    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
